import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { USER_TYPE } from "utils/constants";
import { textFieldStyle } from "utils/NonAuthenticatedStyle";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { dateStyle } from "utils/DatePickerStyle";
import AutoCompleteField from "components/AutoCompleteField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Drawer,
  Typography,
  TextField,
  Box,
  Stack,
  Button
} from "@mui/material";

const useStyles = makeStyles(theme =>
  textFieldStyle(theme, theme.palette.text.dark.primary)
);

function FilterDrawer({
  date,
  setDate,
  position,
  setBroker,
  brokerValue,
  applyFilters,
  toggleDrawer,
  handleOnFilterChange,
  handleOnDateFilterChange
}) {
  const classes = useStyles();
  const { data: userData, theme } = useSelector(state => state.user);

  return (
    <Drawer
      anchor={"right"}
      open={position["right"]}
      onClose={toggleDrawer(false)}
      sx={theme => ({
        [theme.breakpoints.down("sm")]: {
          "& .MuiDrawer-paper": {
            width: "100%",
            bgcolor: theme.palette.text.dark.primary
          }
        }
      })}
    >
      <Box
        sx={theme => ({
          width: 400,
          padding: "56px 32px",
          [theme.breakpoints.down("sm")]: {
            width: "100%",
            padding: 0
          }
        })}
        role="presentation"
      >
        <Box
          sx={theme => ({
            [theme.breakpoints.down("sm")]: {
              padding: "56px 32px"
            }
          })}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ marginBottom: "24px" }}
          >
            <Typography variant="h4" color="text.primary" component="div">
              FILTER
            </Typography>
            <CloseIcon
              onClick={toggleDrawer(false)}
              sx={{ color: "text.primary" }}
            />
          </Stack>
          <Stack
            sx={theme => ({
              [theme.breakpoints.down("sm")]: {
                width: "100%"
              }
            })}
          >
            <Stack>
              {(userData?.me?.type === USER_TYPE.ADMIN ||
                userData?.me?.type === USER_TYPE.COMPANY_OWNER) && (
                <AutoCompleteField
                  label={"Select Broker"}
                  value={brokerValue?.email || ""}
                  options={userData.brokers?.map(({ id, email }) => ({
                    value: id,
                    label: email
                  }))}
                  onChange={(e, value) => {
                    setBroker(value?.value || "");
                    handleOnFilterChange("broker", value?.value);
                  }}
                />
              )}
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  label="Select Date"
                  value={date}
                  onChange={handleOnDateFilterChange}
                  renderInput={params => (
                    <TextField
                      {...params}
                      className={classes.textField}
                      sx={{ marginTop: "16px" }}
                    />
                  )}
                  PopperProps={{
                    sx: dateStyle(theme)
                  }}
                />
              </LocalizationProvider>
            </Stack>
            <Button
              variant="contained"
              sx={{ marginTop: "16px" }}
              onClick={applyFilters}
            >
              Apply
            </Button>
          </Stack>
        </Box>
      </Box>
    </Drawer>
  );
}

export default FilterDrawer;
